module.exports = KsysAppTemplateV2dot123dot0;